import { ReactElement } from 'react';
import { useTranslation } from 'next-i18next';
import { Link } from '@Hotels-at-Home/hah-fe-core/dist/components';

const RobeSection = (): ReactElement => {
  const { t: tRobe } = useTranslation('', { keyPrefix: '$local.$robeSection' });
  const { t: tLinks } = useTranslation('', { keyPrefix: '$local.$homePageLinks.$robeSection' });
  const { t: tButton } = useTranslation('', { keyPrefix: '$common.$buttons' });

  return (
    <section className="base-section robe-section hp-section">
      {/* Robe Section */}
      <div className="pattern-2-col">
        <Link href={tLinks('robeMain')} className="pattern-2-col-background" id="HP_robe">
          <img
            src="/images/homepage/hp-robes.webp"
            alt={tRobe('robeAlt')}
            className="image-2-col hp-robes"
            loading="lazy"
            decoding="async"
            fetchPriority="low"
            width={650}
            height={457}
          />
          <div className="text-2-col">
            <p className="eyebrow">{tRobe('robeEyebrow')}</p>
            <h2>{tRobe('robeTitle')}</h2>
            <p>{tRobe('robeDescription')}</p>
            <span className="btn-main">{tButton('shopNow')}</span>
          </div>
        </Link>
      </div>
    </section>
  );
};

export default RobeSection;
